import React, { useState, useEffect } from "react";
import { URL } from "shared/utils";
import { useHistory } from "react-router-dom";

import { Item} from "./styles";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const { cdnUrl } = URL;

const MenuItem = ({
  isNested,
  pageUrl,
  imageUrl,
  name,
  isAbsolute,
  disabled,
  onLogout,
  closeMenu,
}) => {
  const history = useHistory();
  
  const gotoPage = (isAbsolute, href) => {
    if (isAbsolute) {
      window.open(href, "_blank", "noopener,noreferrer");
    } else {
      if (href === "/logout") {
        onLogout();
      } else {
        history.push(href);
      }
    }
    // Close the menu after navigation
    if (closeMenu) {
      closeMenu();
    }
  };

  return (
    <Item
      isNested={isNested}
      disabled={disabled}
      onClick={() => !isNested && gotoPage(isAbsolute, pageUrl)}
    >
      {name}
      {isNested && <ChevronRightIcon sx={{ position: "absolute", right: "16px" }} fontSize="small" />}
    </Item>
  );
};

export default MenuItem;
